import { SuburbanBathroomContainer } from '../../containers/advancedFilters/SuburbanBathroomContainer';
import { IFilter } from '../../types/filters';

export const suburbanBathroom: IFilter = {
  component: SuburbanBathroomContainer,
};
